"use client";

import Link from "next/link";
import Image from "next/image";

export default function Footer() {
  return (
    <footer
      className="border-t py-4"
      style={{
        backgroundColor: "var(--pnn-green-dark)",
        borderColor: "rgba(180, 140, 45, 0.3)",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Image
              src="https://pacificnorthnorth-images-noprod.s3.us-east-1.amazonaws.com/assets/PacificNorthNorthInitialLogo.svg"
              alt="Pacific North North Logo"
              width={48}
              height={48}
              className="h-10 w-10 md:h-16 md:w-16"
            />
            <p className="text-sm" style={{ color: 'rgba(180, 140, 45, 0.9)' }}>
              © {new Date().getFullYear()} Pacific North North, a subsidiary of{' '}
              <a 
                href="https://yeix.io" 
                className="underline hover:text-white transition-colors"
                style={{ color: 'rgba(180, 140, 45, 0.9)' }}
              >
                Yeix.io LLC
              </a>
              {' '}— Alaska-First Adventures
            </p>
          </div>
          <div className="flex gap-6 text-sm">
            <Link
              href="/vision"
              className="transition-colors"
              style={{ color: "rgba(180, 140, 45, 0.8)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(180, 140, 45, 0.8)")
              }
            >
              Our Vision
            </Link>
            <Link
              href="/about"
              className="transition-colors"
              style={{ color: "rgba(180, 140, 45, 0.8)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(180, 140, 45, 0.8)")
              }
            >
              About
            </Link>
            <Link
              href="/marketing"
              className="transition-colors"
              style={{ color: "rgba(180, 140, 45, 0.8)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(180, 140, 45, 0.8)")
              }
            >
              Marketing & Brand
            </Link>
            <Link
              href="/terms"
              className="transition-colors"
              style={{ color: "rgba(180, 140, 45, 0.8)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(180, 140, 45, 0.8)")
              }
            >
              Terms
            </Link>
            <Link
              href="/privacy"
              className="transition-colors"
              style={{ color: "rgba(180, 140, 45, 0.8)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(180, 140, 45, 0.8)")
              }
            >
              Privacy
            </Link>
            <Link
              href="/policies/refund"
              className="transition-colors"
              style={{ color: "rgba(180, 140, 45, 0.8)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(180, 140, 45, 0.8)")
              }
            >
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
